export default (selectedSpecialtyArray, specialties) => {
  if (selectedSpecialtyArray.length !== 1) {
    return false;
  }

  const selectedSpecialty = specialties.find(specialty => specialty.id === selectedSpecialtyArray[0]);
  return selectedSpecialty.slug === 'psicologo';
};
